export class AddContactInfoCustomFieldRawDto {
  fieldName: string;
  fieldValue: boolean;
}
